import { doc, getDoc } from 'firebase/firestore';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Scenario from '../../models/Scenario';
import Failure from '../../../core/Failure';

async function getScenarioById(scenarioId: string): Promise<Scenario | null> {
  try {
    const db = firestore;

    const scenarioRef = await getDoc(
      doc(db, FirestoreCollections.scenarios, scenarioId)
    );

    if (!scenarioRef.exists()) {
      return null;
    }

    const scenario = Scenario.fromFirestore(scenarioRef);

    return scenario;
  } catch (e) {
    console.log('error: ', e);
    throw new GetScenarioByIdFailure();
  }
}

export class GetScenarioByIdFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getScenarioById;
